import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { ItemMessageModule } from '../item-message/item-message.module';

const ACCORDION_VALUE = 'accordion-value';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    ItemMessageModule,
  ],
  selector: 'app-card-accordion',
  templateUrl: './card-accordion.component.html',
  styleUrls: ['./card-accordion.component.scss'],
})
export class CardAccordionComponent {
  @Input() accordionLabel = '';
  @Input() mode: 'accordion' | 'card' = 'accordion';

  value = ACCORDION_VALUE;
  @Input() set isOpen(value: boolean) {
    this.value = value ? ACCORDION_VALUE : '';
  }

  ACCORDION_VALUE = ACCORDION_VALUE;
}
